import { DialogHeader } from "@imi/ui/components/Dialog/DialogHeader.js";
import { Heading } from "@imi/ui/components/Heading/Heading.js";
import { Skeleton } from "@imi/ui/components/Skeleton/Skeleton.js";
import { useTranslation } from "react-i18next";
import { DialogLoadingFallback as DefaultLoadingFallback } from "../../../components/DialogLoadingFallback";
import styles from "./DialogLoadingFallback.module.css";

export function DialogLoadingFallback() {
  const { t } = useTranslation("settings", {
    keyPrefix: "technicalPreferences.waterCharacteristics",
  });

  return (
    <>
      <DialogHeader>
        <Heading as="h3" subTitle={t("subTitle")}>
          {t("title")}
        </Heading>
        <div>
          <Skeleton className={styles.BadgeSkeleton} />
        </div>
      </DialogHeader>
      <DefaultLoadingFallback />
    </>
  );
}
